import { useEffect, useState } from "react";
import { firebaseConfig } from "../../services/userService";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Custom Hook for Firebase Initialization
const useFirebaseInit = () => {
    const [firebaseConfigData, setFirebaseConfigData] = useState(null);
    const [firebaseAuth, setFirebaseAuth] = useState(null);
    const [isFirebaseConfigPending, setIsFirebaseConfigPending] = useState(false);
    const [isFirebaseConfigError, setIsFirebaseConfigError] = useState(false);

    // Fetch Firebase config from API or other source
    const fetchFirebaseConfig = async () => {
        setIsFirebaseConfigPending(true);
        try {
            const config = await firebaseConfig(); // Assuming firebaseConfig fetches the config
            setFirebaseConfigData(config);
        } catch (error) {
            setIsFirebaseConfigError(true);
        } finally {
            setIsFirebaseConfigPending(false);
        }
    };

    useEffect(() => {
        fetchFirebaseConfig();
    }, []);

    // Initialize Firebase after config is loaded
    useEffect(() => {
        if (firebaseConfigData) {
            const app = initializeApp(firebaseConfigData);
            const auth = getAuth(app);
            setFirebaseAuth(auth);
        }
    }, [firebaseConfigData]);

    return { firebaseAuth, isFirebaseConfigPending, isFirebaseConfigError, fetchFirebaseConfig };
};

export default useFirebaseInit;
